import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@drl/core/auth/auth.guard';
import {LoggedInGuard} from '@drl/core/auth/logged-in.guard';
import {environment} from '@drl/env/environment';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {LastLoginGuard} from './core/auth/last-login.guard';
import {PermissionKey} from './core/auth/permission-key.enum';
import {JoincallComponent} from './joincall/joincall.component';
import {MainComponent} from './main/main.component';

const routes: Routes = [
  {
    path: 'joinCall',
    component: JoincallComponent,
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'change-password',
    loadChildren:
      () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'forgot-password',
    loadChildren:
      () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'content',
    loadChildren: () => import('./content-view/content-view.module').then(m => m.ContentViewModule),
  },
  {
    path: 'care-chat',
    loadChildren: () => import('./care-chat/care-chat.module').then(m => m.CareChatModule),
  },
  {
    path: 'patient-records',
    loadChildren:
      () => import('./patient-records/patient-records.module').then(m => m.PatientRecordsModule),
  },
  {
    path: 'main',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),
      },
    ],
    canActivate: [LastLoginGuard, NgxPermissionsGuard],
    canActivateChild: [LastLoginGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        except: [PermissionKey.CanViewMedicalRecordsOnly],
        redirectTo: environment.errorPath,
      },
    },
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
  },
  {
    path: '',
    redirectTo: environment.homePath,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: environment.homePath,
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
